import { Box, Typography } from '@mui/material';
import { USER_TYPE } from '../../../utils/constants';
import { containsAnyKeys } from '../../../utils/objectHelpers';

const columns = (renderCell, renderOrdersCell, renderQuotesCell, user, renderActions, renderCompaniesCell, renderAccessLevelTypeCell, emailEditable, renderSellersCell, renderInventoryCell, renderValueCell, renderSpecialInstructionsCell, renderPersonnelCell, renderAccessLevelsCell, renderSpendCell, renderFavoritesCell, renderUserActiveCell) => {
  const editPermissions = [USER_TYPE.PREMIUM_ADMIN, USER_TYPE.PREMIUM_REALTIME_MPD_ADMIN, USER_TYPE.PREMIUM_MARKETPLACE_ADMIN, USER_TYPE.PREMIUM_FIELD_TICKETING_ADMIN];
  const showAndEditCells = editPermissions.includes(user.type) || (user.type === USER_TYPE.PREMIUM_SELECT_ADMIN && containsAnyKeys(editPermissions, user.accessLevels));

  return [
    {
      field: 'active',
      headerName: '',
      renderCell: renderUserActiveCell,
      headerAlign: 'center',
      width: 80,
      hide: !(user.type === USER_TYPE.PREMIUM_ADMIN || (user.type === USER_TYPE.PREMIUM_SELECT_ADMIN && user.accessLevels.includes(USER_TYPE.PREMIUM_ADMIN))),
    },
    {
      field: 'firstName',
      headerName: 'Name',
      width: 300,
      renderCell,
      renderEditCell: renderValueCell,
      editable: showAndEditCells,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'emailAddress',
      headerName: 'Email',
      width: 400,
      renderCell,
      renderEditCell: renderValueCell,
      editable: user.type === USER_TYPE.PREMIUM_ADMIN || (showAndEditCells && emailEditable),
      headerAlign: 'center',
      align: 'center'
    },
    {
      field: 'phone',
      headerName: 'Phone',
      width: 200,
      // eslint-disable-next-line
      hide: showAndEditCells ? false : true,
      renderCell,
      renderEditCell: renderValueCell,
      editable: showAndEditCells,
      headerAlign: 'center',
      align: 'center'
    },
    {
      field: 'companyName',
      headerName: 'Company',
      width: 350,
      renderCell,
      editable: showAndEditCells,
      headerAlign: 'center',
      align: 'center',
      renderEditCell: renderCompaniesCell
    },
    {
      field: 'type',
      headerName: 'Type',
      width: 300,
      renderCell,
      editable: showAndEditCells,
      headerAlign: 'center',
      align: 'center',
      renderEditCell: renderAccessLevelTypeCell
    },
    {
      field: 'accessLevels',
      headerName: 'Access Levels',
      width: 120,
      renderCell: renderAccessLevelsCell,
      hide: !(user.type === USER_TYPE.PREMIUM_ADMIN || (user.type === USER_TYPE.PREMIUM_SELECT_ADMIN && user.accessLevels.includes(USER_TYPE.PREMIUM_ADMIN))),
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'orders',
      headerName: 'Orders',
      width: 100,
      headerAlign: 'center',
      align: 'center',
      renderCell: renderOrdersCell,
    },
    {
      field: 'quotes',
      headerName: 'Quotes',
      width: 100,
      headerAlign: 'center',
      align: 'center',
      renderCell: renderQuotesCell,
    },
    {
      field: 'sellers',
      headerName: 'Sellers',
      width: 100,
      headerAlign: 'center',
      align: 'center',
      renderCell: renderSellersCell,
      // eslint-disable-next-line
      hide: user.type === USER_TYPE.PREMIUM_ADMIN || user.type === USER_TYPE.PREMIUM_MARKETPLACE_ADMIN || (user.type === USER_TYPE.PREMIUM_SELECT_ADMIN && containsAnyKeys([USER_TYPE.PREMIUM_ADMIN, USER_TYPE.PREMIUM_MARKETPLACE_ADMIN], user.accessLevels)) ? false : true,
    },
    {
      field: 'Inventory',
      headerName: 'Inventory',
      width: 100,
      renderCell: renderInventoryCell,
      // eslint-disable-next-line
      hide: user.type === USER_TYPE.PREMIUM_ADMIN || user.type === USER_TYPE.PREMIUM_MARKETPLACE_ADMIN || user.type === USER_TYPE.PREMIUM_MARKETPLACE_ADMIN || (user.type === USER_TYPE.PREMIUM_SELECT_ADMIN && containsAnyKeys([USER_TYPE.PREMIUM_ADMIN, USER_TYPE.PREMIUM_MARKETPLACE_ADMIN], user.accessLevels)) || user.type === USER_TYPE.SELLER_MARKETPLACE_ADMIN || user.type === USER_TYPE.CUSTOMER_MANAGER || user.type === USER_TYPE.CUSTOMER_ADMIN ? false : true,
      headerAlign: 'center',
    },
    {
      field: 'specialInstructions',
      width: 100,
      renderHeader: () => (
        <Box>
        <Typography sx={{ fontSize: '0.875rem', fontWeight: 'bold' }}>
          Special
        </Typography>
        <Typography sx={{ fontSize: '0.875rem', fontWeight: 'bold' }}>
          Instructions
        </Typography>
        </Box>
      ),
      // eslint-disable-next-line no-unneeded-ternary
      hide: user.type === USER_TYPE.PREMIUM_ADMIN || (user.type === USER_TYPE.PREMIUM_SELECT_ADMIN && user.accessLevels.includes(USER_TYPE.PREMIUM_ADMIN)) || user.type === USER_TYPE.CUSTOMER_MANAGER ? false : true,
      renderCell: renderSpecialInstructionsCell,
      headerAlign: 'center',
      align: 'center'
    },
    {
      field: 'personnel',
      headerName: 'Personnel',
      width: 100,
      // eslint-disable-next-line no-unneeded-ternary
      hide: user.type === USER_TYPE.PREMIUM_ADMIN || (user.type === USER_TYPE.PREMIUM_SELECT_ADMIN && user.accessLevels.includes(USER_TYPE.PREMIUM_ADMIN)) || user.type === USER_TYPE.CUSTOMER_MANAGER ? false : true,
      renderCell: renderPersonnelCell,
      headerAlign: 'center',
      align: 'center'
    },
    {
      field: 'spend',
      headerName: 'Spend',
      width: 100,
      // eslint-disable-next-line
      hide: user.type === USER_TYPE.PREMIUM_ADMIN || (user.type === USER_TYPE.PREMIUM_SELECT_ADMIN && user.accessLevels.includes(USER_TYPE.PREMIUM_ADMIN)) || user.type === USER_TYPE.CUSTOMER_MANAGER || user.type === USER_TYPE.CUSTOMER_ADMIN  || user.type === USER_TYPE.SELLER_MARKETPLACE_ADMIN || user.type === USER_TYPE.PREMIUM_MARKETPLACE_ADMIN ? false : true,
      renderCell: renderSpendCell,
      headerAlign: 'center',
      align: 'center'
    },
    {
      field: 'isPartsFavorites',
      headerName: 'Favorites',
      width: 100,
      // eslint-disable-next-line
       hide: user.type === USER_TYPE.PREMIUM_ADMIN || user.type === USER_TYPE.CUSTOMER_MANAGER || user.type === USER_TYPE.CUSTOMER_ADMIN  ? false : true,
      renderCell: renderFavoritesCell,
      headerAlign: 'center',
      align: 'center'
    },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 120,
      // eslint-disable-next-line
      hide: showAndEditCells ? false : true,
      headerAlign: 'center',
      align: 'center',
      renderCell: renderActions,
    },
  ];
};

export default columns;
